import React, {Component} from 'react';
import {connect} from 'react-redux';

import {Card, CardBody, Col, Container, Row} from "reactstrap";
import ListingStreetMap from "../../../components/media/maps/ListingStreetMap";
import Loader from "../../../components/display/Loader";
import {fetchListings} from "../../listings/actions/listings";
import PolyUtil from "../../../util/PolyUtil";

import ReduxModalWrapper from "../../../components/display/Modals/ReduxModalWrapper";
import Stepper from "../../../components/controls/inputs/Stepper";
import ListingCard from "../../../components/properties/ListingCard";

class ExploreContainer extends Component {
    state = {
        location: null,
        isLoading: true,
        filters: {
            maxRent: null,
            bedrooms: null,
            bathrooms: null,
            maxTenants: null,
            fitsGroup: false
        },
        waiting: [],
    };

    componentWillMount() {
        this.props._fetchListings();
        this.fetchLocation();
    }

    fetchLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                this.setState({isLoading: false, location: {lat: position.coords.latitude, lng: position.coords.longitude}});
            });
        } else {
            console.log("Unsupported");
            this.setState({isLoading: false, location: "unsupported"});
        }
    };

    setFilters = (filters) => {
        const length = this.state.waiting.length;
        this.setState({
            waiting: [...this.state.waiting, filters]
        });

        setTimeout(() => {
            if (this.state.waiting.length - 1 === length) {
                this.setState({
                    filters: {
                        ...this.state.filters,
                        ...filters,
                    },
                    waiting: [],
                });
            }

        }, 1000);
    };

    validateFilters = (filters) => {
        const {bedrooms, bathrooms, maxRent, maxTenants} = filters || this.state.filters;
        const valid = {};

        if (maxRent !== null && maxRent < 0) {
            valid.maxRent = false;
        }

        if (bedrooms !== null && bedrooms < 0) {
            valid.bedrooms = false;
        }

        if (bathrooms !== null && bathrooms < 0) {
            valid.bathrooms = false;
        }

        if (maxTenants !== null && maxTenants <= 0) {
            valid.maxTenants = false;
        }

        return valid;
    };

    render() {
        const {listings} = this.props;
        const {bedrooms, bathrooms, maxRent, maxTenants} = this.state.filters;
        const filtered = listings && Object.keys(listings).filter((key) => {
            return (this.validateFilters().maxRent === false || maxRent === null) ? true : listings[key].rent <= maxRent;
        }).filter((key) => {
            return bedrooms !== null ? listings[key].prop.bedrooms >= bedrooms : true;
        }).filter((key) => {
            return bathrooms !== null ? listings[key].prop.bathrooms >= bathrooms : true;
        }).filter((key) => {
            return maxTenants !== null ? listings[key].prop.max_tenants >= maxTenants : true;
        }).reduce((obj, key) => {
            return {
                ...obj,
                [key]: listings[key]
            };
        }, {});

        const resultsData = (this.state.waiting.length > 0 || !filtered || !listings) ? (
            <i className="fa fa-pulse fa-spinner"/>
        ) : Object.keys(filtered).length + " Results";

        const listingCards = filtered && Object.keys(filtered).map(function (key, i) {
            const listing = Object.assign({}, listings[key], {
                display_address: PolyUtil.getPropertyStreetAddress(listings[key].prop),
                city: PolyUtil.getPropertyCity(listings[key].prop),
                state: PolyUtil.getPropertyState(listings[key].prop),
            });
            return (
                <Col key={i} xs={12} sm={3}>
                    <ListingCard listing={listing} parent="explore"/>
                </Col>
            );
        });
        console.log("Filtered!", filtered);
        return listings !== null ? (
            <Container>
                <Loader spin isLoading={this.state.isLoading || !filtered}>
                    <Row className="mt-3 mb-2">
                        <Col className="d-flex flex-row justify-content-between w-100">
                            <h3>
                                Explore PolyRents Listings -
                                <small>{" "}{resultsData}</small>
                            </h3>
                        </Col>
                    </Row>
                    <Row className="mb-3 animated fadeIn">
                        <Col>
                            <Card style={{borderRadius: '20px'}}>
                                <CardBody className="p-0">
                                    {
                                        location !== 'unsupported' ? (
                                            <ListingStreetMap location={this.state.location} height="25rem" style={{borderRadius: '20px'}} listings={filtered}/>
                                        ) : (
                                            <div>
                                                <h4>Uh oh...</h4>
                                                <p>It looks like the browser you're using doesn't support location services. Try loading this page again on a different browser or device.</p>
                                            </div>
                                        )
                                    }
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <div className="d-flex justify-content-around flex-wrap w-100">
                            <Stepper label="Rent is less than" prefix="$" postfix="/mo" min={0} step={200} onChange={(value) => this.setFilters({maxRent: value})}/>
                            <Stepper label="At least" postfix=" Bedrooms" min={0} onChange={(value) => this.setFilters({bedrooms: value})}/>
                            <Stepper label="At least" postfix=" Bathrooms" min={0} onChange={(value) => this.setFilters({bathrooms: value})}/>
                            <Stepper label="Can hold at least" postfix=" Tenants" min={0} onChange={(value) => this.setFilters({maxTenants: value})}/>
                        </div>
                    </Row>
                    {
                        !filtered || Object.keys(filtered).length === 0 ? (<h5 className="text-warning text-center mt-3">No listings found</h5>) : (
                            <Row>
                                    {listingCards}
                            </Row>
                        )
                    }
                    <ReduxModalWrapper size="lg" id="map_listing_modal" footerStyle={{width: '100%'}}/>
                </Loader>
            </Container>
        ) : (
            <div className="text-center mt-4">
                <h2 className="text-primary">Uh oh!</h2>
                <p>We coudln't find any public listings. Try again soon!</p>
            </div>
        );
    }

}

const mapStateToProps = (state) => ({
    listings: PolyUtil.objEmpty(state.listings) ? null : state.listings,
    roommateGroupSize: state.tenant.roommate_group.roommates.length,
});

const mapDispatchToProps = (dispatch) => ({
    _fetchListings() {
        return dispatch(fetchListings());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(ExploreContainer);


// WEBPACK FOOTER //
// ./src/containers/tenant/explore/ExploreContainer.js